import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Files } from '../../models/file';
import { NgxFfmService } from '../../ngx-ffm.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Documents } from '../../ngx-ffm.component';
import { NewRegistrationDialogComponent } from '../dialogs/new-registration-dialog/new-registration-dialog.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'file-directories',
  templateUrl: './file-directories.component.html',
  styleUrls: ['./file-directories.component.css']
})
export class FileDirectoriesComponent implements OnInit, OnChanges {
  @Input() directoryInput: Files;
  @Output() outputdir = new EventEmitter<any>();
  file: Files;
  arrDirectories = [];
  arrDirectoryCopy = [];
  arrDocuments = [];
  arrDocumentsCopy = [];
  openableExtensions = ['txt', 'py', 'png', 'jpg', 'jpeg', 'gif', 'md', 'css', 'pdf', 'json'];
  load = false;
  public imgUrl = ' ';
  public base64Image;

  constructor(
    public ngxFfmService: NgxFfmService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.file = new Files(this.directoryInput);
    //this.loadDirectories(this.file.filePath);
  }

  ngOnChanges(): void {
    this.file = new Files(this.directoryInput);
    this.loadDirectories(this.file.filePath);
  }

  async loadDirectories(filePath) {
    this.load = true;
    await this.ngxFfmService.getDocuments(filePath).then(async data => {
      if (data.length === 0) {
        this.arrDirectories = [];
        this.openSnackBar('No directory exist or the directory is empty', 'OK');
      } else {
        this.arrDirectoryCopy = [];
        this.arrDirectories = [];
        this.arrDirectoryCopy = data;
        this.arrDirectoryCopy.forEach(element => {
          const docObj: Documents = {};
          let filteredDoc = [];
          const asd: string[] = element.replace(/ /g, ',').split(',');
          filteredDoc = asd.filter(doc => {
            return doc !== '';
          });
          filteredDoc.forEach((docdata, index) => {
            if (index === 2) {
              docObj.owner = docdata;
            } else if (index === 3) {
              docObj.group = docdata;
            } else if (index === 4) {
              docObj.size = docdata;
            } else if (index === 5) {
              docObj.mt = filteredDoc[index] + ' ' + filteredDoc[index + 1] + ' ' + filteredDoc[index + 2];
            } else if (index === 8) {
              if (filteredDoc[index + 1] === undefined) {
                docObj.filename = docdata;
              } else {
                docObj.filename = docdata + ' ' + filteredDoc[index + 1];
              }
            }
            if (index === filteredDoc.length - 1) {
              if (filteredDoc[0].includes('d')) {
                this.arrDirectories.push(docObj);
              }
            }
          });
        });
        /* let files = [];
        for (let i = 0; i < this.arrDirectories.length; i++) {
          files = await this.loadDocuments(`${this.file.filePath}/${this.arrDirectories[i].filename}`);
          this.arrDirectories[i].files = files as Array<any>;
        } */
      }
      this.load = false;
    });
    const result = {
      type: 'select',
      value: this.arrDirectories
    };
    this.outputdir.emit(result);
    return this.arrDirectories;
  }

  async loadDocuments(filePath) {
    await this.ngxFfmService.getDocuments(filePath).then(async data => {
      if (data.length === 0) {
        this.arrDocuments = [];
      } else {
        this.arrDocumentsCopy = [];
        this.arrDocuments = [];
        this.arrDocumentsCopy = data;
        this.arrDocumentsCopy.forEach(element => {
          const docObj: Documents = {};
          let filteredDoc = [];
          const asd: string[] = element.replace(/ /g, ',').split(',');
          filteredDoc = asd.filter(doc => {
            return doc !== '';
          });
          filteredDoc.forEach((docdata, index) => {
            if (index === 2) {
              docObj.owner = docdata;
            } else if (index === 3) {
              docObj.group = docdata;
            } else if (index === 4) {
              docObj.size = docdata;
            } else if (index === 5) {
              docObj.mt = filteredDoc[index] + ' ' + filteredDoc[index + 1] + ' ' + filteredDoc[index + 2];
            } else if (index === 8) {
              if (filteredDoc[index + 1] === undefined) {
                docObj.filename = docdata;
              } else {
                docObj.filename = docdata + ' ' + filteredDoc[index + 1];
              }
            }
            if (index === filteredDoc.length - 1) {
              if (!filteredDoc[0].includes('d')) {
                this.arrDocuments.push(docObj);
              }
            }
          });
        });

        this.arrDocuments.map(doc => {
          const splitList = doc.filename.split('.');
          const extension = splitList[splitList.length - 1];
          if (this.openableExtensions.includes(extension)) {
            doc.canOpen = true;
          } else {
            doc.canOpen = false;
          }
          if (parseInt(doc.size) < 10000000) {
            doc.large = false;
          } else {
            doc.large = true;
          }
          doc.select = false;
        });
      }

    });
    return this.arrDocuments;
  }

  /* async getAllFiles(array, filepath) {
    let arrResult = [];
    if (array.length !== 0) {
      const arrFiles = [];
      array.forEach(file => {
        if (file.filename.includes('preview') && arrFiles.length !== 1) {
          arrFiles.push(file.filename);
        }
      });
      if (arrFiles.length !== 0) {
        await this.ngxFfmService.getAllFiles({ files: arrFiles, filepath }).then(datafile => {
          arrResult = JSON.parse(JSON.stringify(datafile));
        }, error => {

        });
      } else {
        arrResult = [];
      }
      return arrResult;
    }

  } */

  btnNewDirectory_Click() {
    const dialogRef = this.dialog.open(NewRegistrationDialogComponent, {
      panelClass: 'myapp-no-padding-dialog',
      height: '50vh',
      width: '50vw',
      data: this.file.filePath
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        await this.loadDirectories(this.file.filePath);
      }
    });

  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 4000,
      panelClass: ['blue-snackbar'],

    });
  }
}
